import { render, staticRenderFns } from "./DasDoor.vue?vue&type=template&id=5120b5ab&scoped=true&"
import script from "./DasDoor.vue?vue&type=script&lang=js&"
export * from "./DasDoor.vue?vue&type=script&lang=js&"
import style0 from "./DasDoor.vue?vue&type=style&index=0&id=5120b5ab&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5120b5ab",
  null
  
)

export default component.exports